import * as Redux from 'redux';
export function composeEnhancers(enhancers) {
    const composeEnhancersWrapper = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || Redux.compose;
    return composeEnhancersWrapper(enhancers);
}
